import { Formik } from 'formik';
import type { Dispatch, SetStateAction } from 'react';
import type { CloudUploadScope } from 'api/apiCloudflare';
import { useService } from '../context/ServiceProvider';
import type { ServiceEditType } from '../types';
import useSaveServiceCard from './model/useSaveServiceCard';
import ServiceForm from './ServiceForm';

interface ServiceFormikProps {
    service: ServiceEditType;
    fetchServices: (force?: boolean) => Promise<unknown>;
    setService: Dispatch<SetStateAction<ServiceEditType | null>>;
}

const ServiceFormik = ({ service, fetchServices, setService }: ServiceFormikProps) => {
    const { setShowEditService } = useService();
    const { saveServiceCard } = useSaveServiceCard({
        fetchServices,
        setService,
        setShowEditService,
    });

    return (
        <Formik
            initialValues={{
                ...service,
            }}
            onSubmit={async (values, { setSubmitting }) => {
                await saveServiceCard(values, {
                    entityId: Number(service.ID || values.ID || 0),
                    close: true,
                });
                setSubmitting(false);
            }}
        >
            {({ handleSubmit, isSubmitting, setFieldValue, values }) => {
                const ensureSaved = async (): Promise<CloudUploadScope | false> => {
                    const result = await saveServiceCard(values as ServiceEditType, {
                        entityId: Number(service.ID || values.ID || 0),
                        close: false,
                    });
                    if (!result.ok) return false;

                    setFieldValue('ID', result.entityId);
                    setFieldValue('servArticle', result.values.servArticle);
                    setFieldValue('servName', result.values.servName);
                    setFieldValue('dimensionId', result.values.dimensionId);
                    return { serviceId: result.entityId };
                };

                return (
                    <ServiceForm
                        service={service}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        setFieldValue={setFieldValue}
                        values={values as ServiceEditType}
                        ensureSaved={ensureSaved}
                    />
                );
            }}
        </Formik>
    );
};

export default ServiceFormik;
